import jack from '../logos/avataaars.png';
import luca from '../logos/avataaars2.png'
import ruth from '../logos/avataaars5.png'
import benedetta from '../logos/avataaars4.png'

// Function to calculate the profit
function calculateProfit(startYear, startMonth, profitPerMonth) {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth(); // 0-based index (January is 0)

    let monthsActive = 0;

    // Calculate the number of months the author has been active
    if (currentYear > startYear) {
        monthsActive += (currentYear - startYear - 1) * 12 + (12 - startMonth) + (currentMonth + 1);
    } else if (currentYear === startYear) {
        monthsActive = (currentMonth + 1) - startMonth;
    }

    // Calculate the total profit
    const totalProfit = monthsActive * profitPerMonth;

    // Round down the total profit to the nearest 1000
    const roundedProfit = totalProfit > 20000 ? Math.ceil(totalProfit / 5000) * 5000 : Math.floor(totalProfit / 1000) * 1000;

    return roundedProfit;
}

// Example authorConfig
const authorConfig = {
    1: {
        name: "Jack",
        img: jack, // Assuming an image or image path variable
        since: 2015,
        profitPerMonth: 800,
        profit: calculateProfit(2015, 6, 450), // Call the function here
        method: "I've been side-hustling on-and-off alongside my work as a writer for over a decade, and want to help others profit too.",
        images: [benedetta,luca, ruth]
    },
    2: {
        name: "Luca",
        img: luca, // Assuming an image or image path variable
        since: 2017,
        profitPerMonth: 500,
        profit: calculateProfit(2015, 2, 500), // Call the function here
        method: "I've been earning extra since I was a student, with a bit of time in the evening and weekends while working as a full-time dev ever since.",
        images: [benedetta, jack, ruth]
    },
    3: {
        name: "Ruth",
        img: ruth, // Assuming an image or image path variable
        since: 2024,
        profitPerMonth: 1000,
        profit: calculateProfit(2024, 11, 900), // Call the function here
        method: "I wanted to earn extra on my maternity leave, and never looked back. I want to help others fund that bit extra too.",
        images: [benedetta, jack,luca]
    },
    4: {
        name: "Benedetta",
        img: benedetta, // Assuming an image or image path variable
        since: 2019,
        profitPerMonth: 620,
        profit: calculateProfit(2021, 2, 700), // Call the function here
        method: "I started matched betting to help save for a house alongside my freelance writing work, and love to help others meet their goals.",
        images: [jack,luca, ruth]
    }
};

export default authorConfig;